<template>
  <div>
    <transition name="menu">
      <div class="menu-container" v-if="menuIsOpen">
    
        <div class="menu-icon animated-icon menu-cross" @click="changeMenuStatus" :class="{ anim : menuIsOpen}">
          <div class="ani"></div>
        </div>

        <div  class="menu-mask pan-column pan-center" >
      
          <!-- Medik8 Logo that leads to the homepage -->
          <div class="mdk8-logo">
            <router-link to="/"><img 
                src="../assets/logos/by-medik8-xl.png"
                srcset="../assets/logos/by-medik8-s.png 300w,
                        ../assets/logos/by-medik8-l.png 600w,
                        ../assets/logos/by-medik8-xl.png 900w"
                alt="By Medik8 Logo"></router-link>
          </div>

          <!-- Menu Links -->
          <div class="menu-links pan-column pan-center">
            <!-- R-Retinoate Range -->
            <h2 class="pan-txt-l">{{ $t("menu.DISCOVER") }}</h2>
            <router-link  class="animate-underline" :to="'/#'+ this.$t('homepage.tooltips.two')" v-html="$t('menu.rrrange')"></router-link>
            <router-link  class="animate-underline" to="/youth-activating-cream" > {{ $t("menu['YOUTH ACTIVATING CREAM']") }} </router-link>
            <router-link  class="animate-underline" to='/youth-activating-cream-intense'> {{ $t("menu['YOUTH ACTIVATING CREAM INTENSE']") }} </router-link>
            <router-link  class="animate-underline" to='/rejuvenating-eye-system'> {{ $t("menu['REJUVENATING EYE SYSTEM']") }} </router-link>

            <!-- Our Story Range -->
            <h2 class="pan-txt-l">{{ $t("menu['OUR STORY']") }}</h2>
            <router-link  class="animate-underline" to='/8-year-masterpiece'>{{ $t("menu['8 YEAR MASTERPIECE']") }}</router-link>
            <router-link  class="animate-underline" to='/by-medik8'>{{ $t("menu['BY MEDIK8']") }}</router-link>

            <!-- Main Site -->
            <a :href="$core.header.shop" target="_blank"><h2>{{ $t("menu['mainShop']") }}</h2></a>
            
          </div>

          <!-- Menu footer -->
          <div class="menu-footer pan-push-bottom">
            <div class="menu-social-icons">
              <a :href="$core.footerlinks.facebook" target="_blank"><i class="fab fa-facebook-f"></i></a> 
              <a :href="$core.footerlinks.instagram" target="_blank"><i class="fab fa-instagram"></i></a> 
              <a :href="$core.footerlinks.youtube" target="_blank"><i class="fab fa-youtube"></i></a> 
            </div>

            <div class="menu-legal">
               <a :href="$core.header.homepage" target="_blank">{{ $t("footerlinks['mainSite']") }}</a>
              <!-- <a :href="$core.footerlinks.contact" target="_blank">{{ $t("footerlinks['contact']") }}</a>
              <span/>
              <a :href="$core.footerlinks.privacy" target="_blank">{{ $t("footerlinks['privacy']") }}</a> -->
            </div>
          </div>
        </div>

        <div style="position:fixed;left:0px;z-index:100;width:100%;height:100%;" @click="changeMenuStatus"></div>

      </div>

    </transition>
    <div style="position:fixed;left:0px;background:rgba(0,0,0,0.9);z-index:80;width:100%;height:100%;" v-if="menuIsOpen"></div>
  
  </div>
</template>


<script>
  export default{
     methods: {
      changeMenuStatus() {
        this.$store.state.menuIsOpen = !this.$store.state.menuIsOpen;
      }
    },
    computed: {
      menuIsOpen() {
        return this.$store.state.menuIsOpen;
      }
    },
    watch:{
      $route (to, from){
        return this.$store.state.menuIsOpen = false;
      }
    } 
  }
</script>


<style lang="scss" scoped>

@import '../assets/styles/_vars';
.menu-container{
  display:flex;
  flex-direction:row;
  height: 100%;
  left: 0;
  position:fixed;
  top: 0;
  width: 100%;
  z-index:110;
  
  //Menu Button
  .menu-cross{
    position:fixed;
    left:10px;
    top:20px;
    transition:all 0.4s ease-out;
    z-index:130;
    &.anim {
      left:260px;
      @media screen and (min-width:1360px){
        left:400px;
      }
    }
  }
}

.menu-mask {
  position:relative;
  height:100%;
  z-index:120;
  width:320px;
  background: black;
  padding: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-right:1px solid #222;
  @media screen and (min-width:1360px){
    width:450px;
  }

  h2{
    color:#fff;
    margin-top:40px;
    font-size:20px;
  }

  a{
    color: #fff;
    text-decoration: none;
    transition: all 0.3s ease-out;
    margin-top:10px;
    text-align:center;
  }
  .mdk8-logo,
  .medik8-links,
  .medk8-legal{
    flex-grow:1;
  }

  //Mdk8 Logo
  .mdk8-logo{
    max-width:100px;
    margin:40px 20px 0 20px;
    display:none;
    @media screen and (min-width:1600px){
      display:block;
      margin:60px 20px auto 20px;
      max-width:140px;
    }
    @media screen and (min-width:1921px){
      max-width:200px;
    }
  }
  .menu-links{
    height:100%;
    justify-content:center;
    align-items:center;
    
    a{
      text-align:center; 
      font-size:14px !important;
      &:first-child{
        margin-top:20px;
      }
      @media screen and (max-width:$xs-screens){
        font-size:12px !important;
      }
      @media screen and (min-width:$l-screens){ 
        margin-top:20px;
      }
    }
    h2{
      border-bottom:.5px solid white;
      padding-bottom:10px;
      margin-bottom:0px;
      @media screen and (min-width: $l-screens){
        padding-bottom:13px;
      }
      @media screen and (max-width:$xs-screens){
        font-size:16px !important;
      }
    }   
  }

  .menu-footer{
    margin-top:20px;
    width: 100%;
    transform:scale(0.8);
    @media screen and (min-width:1921px){
      transform:scale(1);
    }
    .menu-social-icons{
      text-align:center;
      a{
        padding:10px;
        font-size: 30px;
        width:70px;
        display:inline-block;
      }
    }

    .menu-legal{
      text-align:center;
      justify-content:center;
      span{
        border-left:1px solid white;
        width:1px;
        margin-left:10px;
        margin-right:10px;
      }
      a{
        padding:0px 5px;
      }
    }
  }
}

// Menu links transitions
.menu-enter {
  opacity:0;
  transform: translateX(-100%);
}

.menu-enter-to {
  opacity:1;
  transition: all 0.3s ease-out;
  transform: translateX(0);
}

.menu-leave-active{
    transform:translateX(-100%);
    transition: all 0.3s ease-out;
}
</style>
